import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgSubscriptionIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    {...props}
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
  >
    <path
      d="m21.485 11.125-9.022-5a1 1 0 0 0-.968-.001l-8.979 4.96a1 1 0 0 0-.003 1.749l9.023 5.04a.995.995 0 0 0 .973.001l8.977-5a1 1 0 0 0-.002-1.749Zm-9.461 4.73-6.965-3.89 6.917-3.822 6.964 3.859-6.917 3.853Z"
      fill="currentColor"
    />
    <path
      d="M12 22c.17 0 .336-.043.485-.126l9-5-.971-1.748L12 19.856l-8.515-4.73-.971 1.748 9 5A1 1 0 0 0 12 22Zm8-20h-2v2h-2v2h2v2h2V6h2V4h-2V2Z"
      fill="currentColor"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSubscriptionIcon);
export default ForwardRef;
